import cx from 'classnames'
import ReactModal from 'react-modal'

const Modal = ({ isShown, onRequestClose, children }) => (
  <div className={`modal ${isShown && 'is-active'}`}>
    <div className="modal-background"></div>
    <div className="modal-content">{children}</div>
    <button className="modal-close is-large" aria-label="close" onClick={onRequestClose}></button>
  </div>
)

interface ModalProps {
  isOpen?: boolean
  onRequestClose: () => void
  children: React.ReactNode
  header: React.ReactNode
}

export const Modal2 = ({ isOpen, onRequestClose, children, header }: ModalProps) => (
  <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} className={cx('modal', { 'is-active': isOpen })}>
    <div className="modal-background"></div>

    <div className="modal-card">
      <header className="modal-card-head">
        <p className="modal-card-title">{header}</p>
        <button onClick={onRequestClose} className="delete" aria-label="close"></button>
      </header>

      <section className="modal-card-body">{children}</section>
    </div>

    <button className="modal-close is-large" aria-label="close" onClick={onRequestClose}></button>
  </ReactModal>
)
export default Modal
